import {room} from './room.js';
const inside=(x,z,b,r=0)=>x>=b.minX+r&&x<=b.maxX-r&&z>=b.minZ+r&&z<=b.maxZ-r;
// There is no stair or raised teleport surface: desktop and XR share this floor.
export function groundHeight() { return 0; }
export function canOccupy(x,z) {
  if(!Number.isFinite(x)||!Number.isFinite(z)) return false;
  const r=room.radius;
  const main=inside(x,z,room.bounds,r);
  const vestibule=inside(x,z,room.vestibule,r);
  const doorway=x>=room.vestibule.minX+r && x<=room.vestibule.maxX-r && z>=room.bounds.minZ-r && z<=room.bounds.minZ+r;
  if(!main&&!vestibule&&!doorway) return false;
  return !room.obstacles.some(b=>inside(x,z,{minX:b.minX-r,maxX:b.maxX+r,minZ:b.minZ-r,maxZ:b.maxZ+r}));
}
export function movePlayer(position,delta) {
  let {x,z}=position;
  const n=Math.ceil(Math.hypot(delta.x,delta.z)/.08)||1;
  for(let i=0;i<n;i++) {
    if(canOccupy(x+delta.x/n,z)) x+=delta.x/n;
    if(canOccupy(x,z+delta.z/n)) z+=delta.z/n;
  }
  return {x,z};
}
export function verticalStep(y,velocity,ground,dt) {
  if(y<=ground) return {y:ground,velocity:0};
  const nextVelocity=velocity-9.8*Math.max(0,Math.min(.05,dt));
  const nextY=y+nextVelocity*Math.max(0,Math.min(.05,dt));
  return nextY<=ground?{y:ground,velocity:0}:{y:nextY,velocity:nextVelocity};
}
export function lineClear(a,b) {
  const n=Math.max(1,Math.ceil(Math.hypot(b.x-a.x,b.y-a.y,b.z-a.z)/.04));
  for(let i=1;i<n;i++) {
    const t=i/n,x=a.x+(b.x-a.x)*t,z=a.z+(b.z-a.z)*t,y=a.y+(b.y-a.y)*t;
    if(!inside(x,z,room.bounds)&&!inside(x,z,room.vestibule)) return false;
    if(room.obstacles.some(o=>y<o.height&&inside(x,z,o))) return false;
  }
  return true;
}
export function movementIntent(keys) {
  return {forward:Number(['w','z','ArrowUp'].some(k=>keys.has(k)))-Number(['s','ArrowDown'].some(k=>keys.has(k))),right:Number(['d','ArrowRight'].some(k=>keys.has(k)))-Number(['a','q','ArrowLeft'].some(k=>keys.has(k)))};
}
